import { type ContentObjectList, type Pagination, createContentObjectList } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getFeed } from '../../services';
import { getRegularFeedInfiniteQueryKey } from '../keys';

type P = {
  communityId?: string;
  enabled?: boolean;
  pagination: Omit<Pagination, 'position'>;
  pinned?: boolean;
};

export const useFeedInfiniteQuery = ({ communityId, enabled, pagination, pinned }: P) =>
  useInfiniteQuery<ContentObjectList[], string | undefined, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn({ pageParam: cursor }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: required by backend API */
      const { data } = await getFeed({
        config: { params: { community_id: communityId, cursor, limit: pagination.pageSize, pinned } },
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: required by backend API */

      return data.map((contentObject) => createContentObjectList(contentObject));
    },
    enabled,
    gcTime: 0,
    getNextPageParam: (lastPage) => (lastPage.length < pagination.pageSize ? undefined : lastPage.at(-1)?.id),
    initialPageParam: undefined,
    queryKey: getRegularFeedInfiniteQueryKey({ filter: { communityId, pinned }, pagination }),
  });
